// Components==============
import React, { createContext, useMemo, useState } from 'react';
// =========================

type GlobalBuildingBlocksMountedContextType = {
  buildingBlocksMounted: boolean;
  setBuildingBlocksMounted: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalBuildingBlocksMountedContext = createContext(
  {} as GlobalBuildingBlocksMountedContextType
);

export default function GlobalBuildingBlocksMounted({
  children,
}: {
  children: React.ReactNode;
}) {
  const [buildingBlocksMounted, setBuildingBlocksMounted] = useState(false);

  const value = useMemo(
    () => ({
      buildingBlocksMounted,
      setBuildingBlocksMounted,
    }),
    [buildingBlocksMounted]
  );

  return (
    <GlobalBuildingBlocksMountedContext.Provider value={value}>
      {children}
    </GlobalBuildingBlocksMountedContext.Provider>
  );
}
